// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1tu8H","footer":"ModalInfo_footer__38e0n"};